// @flow

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import isEmpty from 'lodash/isEmpty';

import { getResource } from 'actions/resources/thunks';

import Loader from 'components/loader';
import Tabs from 'components/tabs';
import Wrapper from 'components/shared/wrapper';
import SessionsListHeader from 'components/sessions/list/header';
import PastSessions from 'components/sessions/list/past';
import ScheduledSessions from 'components/sessions/list/scheduled';

import { type EngagementsType } from 'types/engagements';
import { type SessionsType } from 'types/sessions';
import { type SubjectsType } from 'types/subjects';
import { type ClientsType } from 'types/clients';

import localStorageWrapper from 'utils/local-storage-wrapper';

import groupSessionsByEndTime from './helpers';

const TUTOR_PAYMENTS_AUTH = 'TUTOR_PAYMENTS_AUTH';

type StatePropsType = {
  flash: ?Object,
  isLoading: boolean,
  tutoringEngagements: EngagementsType,
  sessions: SessionsType,
  subjects: SubjectsType,
  clients: ClientsType,
};

const mapStateToProps = ({
  application: { flash, isLoading },
  resources: { tutoringEngagements, clients, sessions, subjects },
}): StatePropsType => ({
  flash,
  isLoading,
  tutoringEngagements,
  sessions,
  subjects,
  clients,
});

type DispatchPropsType = {
  dispatchGetResource: typeof getResource,
  dispatchPush: typeof push,
};

const mapDispatchToProps: DispatchPropsType = {
  dispatchGetResource: getResource,
  dispatchPush: push,
};

type PropsType = StatePropsType & DispatchPropsType;

class SessionsList extends Component<PropsType, *> {
  componentDidMount() {
    const { dispatchGetResource } = this.props;

    dispatchGetResource({
      resource: 'sessions',
      includes: ['client', 'tutoringEngagement', 'tutoringEngagement.subject'],
      isTutor: true,
      sort: '-startTime',
      page: { pageSize: 500, pageNumber: 1 },
    });

    dispatchGetResource({
      resource: 'tutoringEngagements',
      page: { pageNumber: 1, pageSize: 1 },
      isTutor: true,
    });
  }

  render() {
    const {
      flash,
      isLoading,
      tutoringEngagements,
      clients,
      sessions,
      subjects,
      dispatchPush,
    } = this.props;
    const {
      attributes: { firstName } = {},
      business: { logoUrl, name } = {},
    } = (localStorageWrapper(TUTOR_PAYMENTS_AUTH).get(): any);

    const engagementDataEmpty = isEmpty(tutoringEngagements);
    const { pastSessions = [], futureSessions = [] } = groupSessionsByEndTime(sessions);

    return (
      <Wrapper hasFlash={!!flash}>
        {isLoading ? (
          <Loader />
        ) : (
          <Fragment>
            <SessionsListHeader
              businessName={name}
              logoUrl={logoUrl}
              firstName={firstName}
              engagementDataEmpty={engagementDataEmpty}
            />
            <Tabs
              tabs={[
                {
                  name: `Schedule (${futureSessions.length})`,
                  content: (
                    <ScheduledSessions
                      dispatchPush={dispatchPush}
                      clients={clients}
                      engagements={tutoringEngagements}
                      futureSessions={futureSessions}
                      pastSessions={pastSessions}
                      engagementDataEmpty={engagementDataEmpty}
                      subjects={subjects}
                    />
                  ),
                },
                {
                  name: 'Past Sessions',
                  content: (
                    <PastSessions
                      clients={clients}
                      engagements={tutoringEngagements}
                      sessions={pastSessions}
                      engagementDataEmpty={engagementDataEmpty}
                      subjects={subjects}
                    />
                  ),
                },
              ]}
            />
          </Fragment>
        )}
      </Wrapper>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SessionsList);



// WEBPACK FOOTER //
// ./src/screens/sessions/list/index.js